import { Routes } from '@angular/router';
import { CandidateLayoutComponent } from './layouts/candidate-layout/candidate-layout';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AdminPanelComponent } from './features/admin-panel/admin-panel-dashboard/admin-panel';
import { ExamLayoutComponent } from './layouts/exam-layout/exam-layout';
import { ExamPanelComponent } from './features/Examination/Examination-panel/exam-panel';
import { ScanQRComponent }  from './features/Examination/Pages/student-varification/scan-qr-screen/scan-qr';
import { adminGuard , candidateGuard, mensaAdminGuard}  from './core/guards/auth.guard';
import { MensaAdminPanelComponent } from  './features/admin-panel/mensa-admin-panel-dashboard/mensa-admin-panel';
import { CommonLayoutComponent } from './layouts/common-layout.component/common-layout';

export const routes: Routes = [
  // Default screen
  // {
  //   path: '',
  //   redirectTo: 'login',
  //   pathMatch: 'full'
  // },

   {
    path: '',
    component: CommonLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/authentication/pages/login/login')
            .then(m => m.OtpLoginComponent)
      },
      {
        path: 'home',
       loadComponent: () =>
          import('./features/authentication/pages/login/login')
            .then(m => m.OtpLoginComponent)
      },
      {
        path: 'about-us',
        loadComponent: () =>
          import('./shared/components/about-us-component/about-us')
            .then(m => m.AboutUsComponent)
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./shared/components/contact-us.component/contact-us')
            .then(m => m.ContactUsComponent)
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./shared/components/support-component/support')
            .then(m => m.SupportComponent)
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./shared/components/terms-and-conditions.component/terms-and-conditions')
            .then(m => m.TermsAndConditionsComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./shared/components/privacy-policy.component/privacy-policy')
            .then(m => m.PrivacyPolicyComponent)
      }
    ]
  },


  {
  path: 'candidate/entry',
  loadComponent: () =>
    import(
      './features/candidates/pages/entry/candidate-entry'
    )
    .then(
      m => m.CandidateEntryComponent
    )
},
{
  path: 'candidate/hall-ticket-entry',
  loadComponent: () =>
    import(
      './features/candidates/pages/entry/hall-ticket-entry'
    )
    .then(
      m => m.HallTicketEntryComponent
    )
},

  // Candidate pages use candidate header + footer
  {
    path: 'candidate',
    component: CandidateLayoutComponent,
    canActivate: [candidateGuard],
    children: [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/candidates/pages/profile/profile')
            .then(m => m.ProfileComponent)
      },
      {
        path: 'booking/state',
        loadComponent: () =>
          import('./features/candidates/pages/booking/state-selection/state-selection')
            .then(m => m.StateSelectionComponent)
      },
      {
        path: 'booking/city',
        loadComponent: () =>
          import('./features/candidates/pages/booking/city-selection/select-city')
            .then(m => m.SelectCityComponent)
      },
      {
        path: 'booking/centre',
        loadComponent: () =>
          import('./features/candidates/pages/booking/centre-selection/select-centre')
            .then(m => m.SelectCentreComponent)
      },
      {
        path: 'booking/date-time',
        loadComponent: () =>
          import('./features/candidates/pages/booking/date-time-selection/select-date-time')
            .then(m => m.SelectDateTimeComponent)
      },
      {
        path: 'booking/confirm',
        loadComponent: () =>
          import('./features/candidates/pages/booking/booking-confirmation/booking-confirm')
            .then(m => m.BookingConfirmComponent)
      },
      {
        path: 'booking/payment-methods',
        loadComponent: () =>
          import('./features/candidates/pages/booking/payment-methods/payment-methods')
            .then(m => m.PaymentMethodsComponent)
      },
      {
        path: 'booking/payment-status',
        loadComponent: () =>
          import('./features/candidates/pages/booking/payment-status/payment-status')
            .then(m => m.PaymentStatusComponent)
      },
      {
        path: 'booking/booking-details',
        loadComponent: () =>
          import('./features/candidates/pages/booking/booking-details/booking-details')
            .then(m => m.BookingDetailsComponent)
      },
      {
        path: 'hall-ticket',
        loadComponent: () =>
          import('./features/candidates/pages/booking/hall-ticket/hall-ticket').then(
            m => m.HallTicketComponent
          )
      }
    ]
  },

  // Admin is separate from CandidateLayoutComponent
  {
  path: 'admin',
  component: AdminLayoutComponent,
  canActivate: [
    adminGuard
  ],
  children: [
    {
      path: 'admin-panel',
      component: AdminPanelComponent,
      children: [
        {
          path: '',
          redirectTo: 'dashboard',
          pathMatch: 'full'
        },
        {
          path: 'dashboard',
          loadComponent: () =>
            import('./features/admin-panel/pages/admin-dashboard/admin-dashboard')
              .then(m => m.DashboardComponent)
        },
        {
          path: 'organization',
          loadComponent: () =>
            import('./features/admin-panel/pages/organization-view/organization-view')
              .then(m => m.OrganizationComponent)
        },
        {
          path: 'organization/create',
          loadComponent: () =>
            import('./features/admin-panel/pages/create-organization/create-organization')
              .then(m => m.CreateOrganizationComponent)
        },
         {
          path: 'organization/view/:id',
          loadComponent: () =>
            import('./features/admin-panel/pages/organization-view/view-specific-organization')
              .then(m => m.ViewOrganizationComponent)
        },
        {
          path: 'exam-slot',
          loadComponent: () =>
            import('./features/admin-panel/pages/exam-slot/exam-slot-view')
              .then(m => m.ExamSchedulingComponent)
        },
        {
          path: 'student-list',
          loadComponent: () =>
            import('./features/admin-panel/pages/student/student-list/student-list')
              .then(m => m.StudentListComponent)
        },
        {
          path: 'live-monitor',
          loadComponent: () =>
            import('./features/admin-panel/pages/live-monitor/live-monitor-list/live-monitor-list')
              .then(m => m.LiveMonitorComponent)
        },
        {
          path: 'exam-record',
          loadComponent: () =>
            import('./features/admin-panel/pages/exam-record/exam-record-list')
              .then(m => m.ExamRecordListComponent)
        },
        {
          path: 'exam-record/:bookingId',
          loadComponent: () =>
            import('./features/admin-panel/pages/exam-record/exam-record')
              .then(m => m.ExamRecordComponent)
        }
      ]
    }
  ]
},


  // mensa Admin is separate from CandidateLayoutComponent
  {
  path: 'mensa-admin',
  component: AdminLayoutComponent,
  canActivate: [
    mensaAdminGuard
  ],
  children: [
    {
      path: 'admin-panel',
      component: MensaAdminPanelComponent,
      children: [
        {
          path: '',
          redirectTo: 'dashboard',
          pathMatch: 'full'
        },
        {
          path: 'dashboard',
          loadComponent: () =>
            import('./features/admin-panel/pages/admin-dashboard/admin-dashboard')
              .then(m => m.DashboardComponent)
        },
        {
          path: 'organization',
          loadComponent: () =>
            import('./features/admin-panel/pages/organization-view/organization-view')
              .then(m => m.OrganizationComponent)
        },
        {
          path: 'organization/create',
          loadComponent: () =>
            import('./features/admin-panel/pages/create-organization/create-organization')
              .then(m => m.CreateOrganizationComponent)
        },
         {
          path: 'organization/view/:id',
          loadComponent: () =>
            import('./features/admin-panel/pages/organization-view/view-specific-organization')
              .then(m => m.ViewOrganizationComponent)
        },
        {
          path: 'exam-slot',
          loadComponent: () =>
            import('./features/admin-panel/pages/exam-slot/exam-slot-view')
              .then(m => m.ExamSchedulingComponent)
        },
        {
          path: 'student-list',
          loadComponent: () =>
            import('./features/admin-panel/pages/student/student-list/student-list')
              .then(m => m.StudentListComponent)
        },
        {
          path: 'live-monitor',
          loadComponent: () =>
            import('./features/admin-panel/pages/live-monitor/live-monitor-list/live-monitor-list')
              .then(m => m.LiveMonitorComponent)
        },
        {
          path: 'exam-record',
          loadComponent: () =>
            import('./features/admin-panel/pages/exam-record/exam-record-list')
              .then(m => m.ExamRecordListComponent)
        },
        {
          path: 'exam-record/:bookingId',
          loadComponent: () =>
            import('./features/admin-panel/pages/exam-record/exam-record')
              .then(m => m.ExamRecordComponent)
        }
      ]
    }
  ]
},

 // Exam layout
  {
  path: 'exam',
  component: ExamLayoutComponent,
  children: [
    {
      path: 'exam-panel',
      component: ExamPanelComponent,
      children: [
        {
          path: '',
          redirectTo: 'scan-qr',
          pathMatch: 'full'
        },
        {
            path:'scan-qr',
            component: ScanQRComponent
        },

        {
          path: 'exam-instructions',
          loadComponent: () =>
            import('./features/Examination/Pages/student-varification/exam-instructions/exam-instructions')
              .then(m => m.ExamInstructionsComponent)
        },

        {
          path: 'verification-steps',
          loadComponent: () =>
            import('./features/Examination/Pages/student-varification/verification-steps/varification-home-screen/varification-home-screen')
              .then(m => m.VerificationHomeScreenComponent)
        },

        {
          path: 'proctored-exam',
          loadComponent: () =>
            import('./features/Examination/Pages/exam-monitor/proctored-exam')
              .then(m => m.ProctoredExamComponent)
        },

      ]
    }
  ]
},

  // Unknown URL
  {
    path: '**',
    redirectTo: 'login'
  }
];
